import * as React from "react";
export var Input1 = function (_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.title, title = _b === void 0 ? "" : _b, _c = _a.placeholder, placeholder = _c === void 0 ? "" : _c, _d = _a.className, className = _d === void 0 ? "" : _d, _e = _a.error_msg, error_msg = _e === void 0 ? "" : _e;
    return (React.createElement("div", { className: className },
        React.createElement("label", null,
            title,
            " "),
        React.createElement("input", { type: "text", id: "input1", value: value || "", className: "input1", onChange: onChange, placeholder: placeholder }),
        React.createElement("span", null, error_msg)));
};
export var InputType2 = function (_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.title, title = _b === void 0 ? "" : _b, _c = _a.placeholder, placeholder = _c === void 0 ? "" : _c, _d = _a.className, className = _d === void 0 ? "" : _d, _e = _a.error_msg, error_msg = _e === void 0 ? "" : _e, _f = _a.onBlur, onBlur = _f === void 0 ? function () { } : _f;
    return (React.createElement("div", { className: className },
        React.createElement("label", null,
            title,
            " "),
        React.createElement("input", { type: "text", id: "input2", value: value || "", className: "inputType2", onChange: onChange, onBlur: onBlur, placeholder: placeholder }),
        React.createElement("span", null, error_msg)));
};
export var RadioType1 = function (_a) {
    var _b = _a.checked, checked = _b === void 0 ? false : _b, onClick = _a.onClick, _c = _a.title, title = _c === void 0 ? "" : _c, _d = _a.value, value = _d === void 0 ? "1" : _d, _e = _a.className, className = _e === void 0 ? "" : _e;
    return (React.createElement("div", { className: className },
        React.createElement("label", { className: "radioContainer" },
            React.createElement("input", { type: "radio", name: "radio", className: "radioType1", value: value, onClick: onClick, checked: checked }),
            React.createElement("span", { className: "circle" })),
        React.createElement("span", { className: "radio_text" },
            " ",
            title)));
};
